import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { goToIntake } from "@/lib/intake";

export default function StickyMobileCTA() {
  const [visible, setVisible] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 500);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Hide on legal pages where it'd be redundant
  if (location.pathname.startsWith("/legal")) return null;

  return (
    <div
      data-testid="sticky-mobile-cta"
      className={`lg:hidden fixed bottom-3 left-3 right-3 z-30 transition-all duration-300 ${
        visible ? "translate-y-0 opacity-100" : "translate-y-full opacity-0 pointer-events-none"
      }`}
    >
      <button
        type="button"
        onClick={goToIntake}
        data-testid="sticky-mobile-cta-button"
        className="w-full inline-flex items-center justify-center bg-[#2C2B29] text-white rounded-full px-5 py-2.5 text-sm font-semibold shadow-xl hover:bg-[#1f1e1d] transition-colors backdrop-blur-md"
      >
        Start now
        <span className="ml-2" aria-hidden>→</span>
      </button>
    </div>
  );
}
